import type { BillingStatus } from './types';

/** A billing label requires a successful status read, independently of access. */
export function subscriptionStatusLabel(
  status: BillingStatus | undefined
): string | null {
  if (!status?.has_subscription || !status.subscription_status) return null;
  if (status.subscription_status === 'trialing') {
    return status.trial_end
      ? `Trial ends ${new Date(status.trial_end).toLocaleDateString()}`
      : 'Trial';
  }
  const labels = {
    active: 'Active',
    past_due: 'Payment overdue',
    unpaid: 'Unpaid',
    canceled: 'Cancelled',
    incomplete: 'Payment incomplete',
    incomplete_expired: 'Expired',
    paused: 'Paused',
  };
  return labels[status.subscription_status];
}
